import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Radio, CalendarClock, PlayCircle, Headphones, Share2, Lock, Users, Globe, Ticket } from "lucide-react";
import { fmtDateTime } from "@/lib/format";

export const ACCESS = {
  public: { label: "Public", icon: Globe, cls: "bg-[#8FA89B]/15 text-[#3E5A4B]" },
  members: { label: "Members Only", icon: Users, cls: "bg-[#144F75]/10 text-[#144F75]" },
  ticket: { label: "Ticket Holders", icon: Ticket, cls: "bg-[#D98E73]/15 text-[#9A5236]" },
};
const KIND_ICON = { live: Radio, upcoming: CalendarClock, replay: PlayCircle, podcast: Headphones };

export const AccessBadge = ({ level, testid }) => {
  const a = ACCESS[level] || ACCESS.public;
  const Icon = a.icon;
  return <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${a.cls}`} data-testid={testid}><Icon size={11} /> {a.label}</span>;
};

export const shareItem = async (url) => {
  const full = `${window.location.origin}${url}`;
  try { await navigator.clipboard.writeText(full); toast.success("Link copied"); }
  catch { toast.message(full); }
};

export const HubCard = ({ it }) => {
  const Icon = KIND_ICON[it.kind] || PlayCircle;
  const to = it.action === "Get Tickets" ? it.ticket_url : it.url;
  const tid = `${it.source}-${it.id}`;
  return (
    <article className="eyw-card overflow-hidden flex flex-col group" data-testid={`hub-item-${tid}`}>
      <Link to={to} className="relative aspect-video bg-[#144F75]/10 overflow-hidden block" aria-label={it.title}>
        {it.image ? <img src={it.image} alt={it.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
          : <div className="h-full w-full grid place-items-center text-[#144F75]"><Icon size={40} /></div>}
        {it.kind === "live" && <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-red-600 text-white text-xs font-semibold px-3 py-1"><span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" /> LIVE</span>}
        {it.featured && <span className="absolute top-3 right-3 rounded-full bg-white/90 text-[#144F75] text-[11px] font-semibold px-2.5 py-0.5">Featured</span>}
      </Link>
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex flex-wrap items-center gap-2 mb-2">
          <AccessBadge level={it.access} testid={`hub-access-${tid}`} />
          {it.locked && <Lock size={12} className="text-[#9A5236]" />}
        </div>
        <h3 className="text-lg text-[#1A242B] leading-snug" data-testid={`hub-title-${tid}`}>{it.title}</h3>
        <p className="text-xs text-[#8FA89B] mt-1">{it.host ? `with ${it.host} · ` : ""}{it.date ? fmtDateTime(it.date) : ""}</p>
        {it.tags?.length > 0 && <div className="flex flex-wrap gap-1 mt-2">{it.tags.slice(0, 4).map((t) => <span key={t} className="text-[11px] text-[#4A5D6B] bg-[#F5F1EA] rounded-full px-2 py-0.5">#{t}</span>)}</div>}
        <div className="mt-auto pt-4 flex items-center gap-2">
          <Link to={to} data-testid={`hub-action-${tid}`} className={`eyw-btn !py-2 text-sm flex-1 justify-center ${it.kind === "live" ? "!bg-red-600" : ""}`}><Icon size={15} /> {it.action}</Link>
          <button type="button" onClick={() => shareItem(it.url)} aria-label={`Share ${it.title}`} data-testid={`hub-share-${tid}`}
            className="rounded-full border border-[#E5E0D8] p-2.5 text-[#144F75] hover:border-[#144F75] transition-colors"><Share2 size={15} /></button>
        </div>
      </div>
    </article>
  );
};
